import type { Enums } from "../types";

export function getOrderStateColor(state: Enums<"orderState">): Enums<"color"> {
	switch (state) {
		case "complete":
			return "emerald";
		case "in-progress":
			return "accent";
		case "open":
			return "amber";
		case "pending":
			return "gray";
		case "canceled":
			return "gray";
		case "picking":
			return "purple";
	}
}
